import React from 'react';

export class AppErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error('App crashed:', error, info?.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-6 text-center bg-[#0f0d0c] text-white" data-testid="app-error-screen">
        <p className="text-xl font-bold">PAPO</p>
        <p className="text-sm text-white/70 max-w-xs">Algo salió mal al cargar. · Something went wrong. · Algo correu mal.</p>
        <button onClick={() => window.location.reload()} className="rounded-full px-6 py-3 font-bold bg-[#EB2A34]" data-testid="app-error-reload">
          Recargar / Reload
        </button>
      </div>
    );
  }
}
